import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tr from "@/locales/tr.json";
import en from "@/locales/en.json";

const STORAGE_KEY = "ms_lang";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            tr: { translation: tr },
            en: { translation: en },
        },
        fallbackLng: "tr",
        supportedLngs: ["tr", "en"],
        nonExplicitSupportedLngs: true,
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            lookupLocalStorage: STORAGE_KEY,
            caches: ["localStorage"],
        },
        returnNull: false,
        returnEmptyString: false,
    });

export const setLanguage = (lng) => {
    i18n.changeLanguage(lng);
    try { localStorage.setItem(STORAGE_KEY, lng); } catch (e) { /* noop */ }
};

export default i18n;
